import React, { useEffect, useState } from "react";
import SimpleSelect from "../SimpleSelect";
import { useDispatch } from "react-redux";
import { getReport, getReportData, getSideBarData } from "../../redux/actions/intentAction";
import { useSelector } from "react-redux";
import Select from "react-tailwindcss-select";
import Loading from "../assetLibComponents/Loading";
import Jump from "../../assets/zoiJump.gif";


const Intent = (props) => {
  props.pageTypeHandler("Intent");

  const [sidebar,setSidebar]=useState(true);
  const [reportData,setReportData]=useState();
  const [freshnessSelected,setFreshnessSelected]=useState({ id: 1, name: "Day" });
  const [selectedC,setSelectedC]=useState({ id: 1, name: "Company" });
  const [articleNumber,setArticleNumber]=useState("");

  const [formData, setFormData] = useState({
    clientName: '',
    targetIndustries: '',
    aboutSeller: '',
    aboutOffering: '',
  });
  const dispatch = useDispatch();
  const sideData = useSelector(
    (state) =>state.intent?.sidebarData
  );
  const repId = useSelector(
    (state) =>state.intent?.reportId?.report_id
  );
  const repData = useSelector(
    (state) =>state.intent?.reportData?.data?.articles_report
  );
  const repStatus = useSelector(
    (state) =>state.intent?.reportDataMore?.data
  );
  const isLoading = useSelector((state) => state.intent.loading);

  useEffect(()=>{
  //  const oldId = localStorage.getItem("reportId");
    dispatch(getSideBarData(props.authToken));

  },[])

  useEffect(()=>{
    if(repId){
      // localStorage.setItem("reportId", repId);
      dispatch(getReportData(props.authToken,repId));
    }
  },[repId])



  useEffect(()=>{
    if(sideData?.statusCode == "200"){
      setFormData({
        clientName: sideData?.data?.company,
        targetIndustries: sideData?.data?.industry,
        aboutSeller : sideData?.data?.about_client,
        aboutOffering:sideData?.data?.what_they_sell,
      })
    }    
  },[sideData])


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [triggerSelected, setTriggerSelected] = useState("");

  const freshnessTimeline = [
    { id: 1, name: "Day" },
    { id: 2, name: "Week" },
    { id: 3, name: "Month" },
  ];
  const selectTimeline = [
    { id: 1, name: "Company" },
    { id: 2, name: "Industry" },
  ];

  const handleSubmit = (e) => {
    // const newArr = triggerSelected?.map(item=>item?.value)
    const payload =
    {
      freshness : freshnessSelected?.name,
      system_prompt : searchQuery,
      is_company: selectedC?.name === "Company" ? true : false,
      client_company : formData?.clientName,
      industry_or_company_name : formData?.targetIndustries,
      about_seller : formData?.aboutSeller,
      about_offerings : formData?.aboutOffering,
      triggers : triggerSelected,
      no_of_news_articles : articleNumber
  }
  dispatch(getReport(props.authToken,payload));
  }

  // Function to get the ordinal suffix for a day
const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return 'th'; // for 4-20
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

// Function to categorize the score
const categorizeScore = (score) => {
  if (score >= 1 && score <= 3) {
    return 'low';
  } else if (score >= 4 && score <= 7) {
    return 'medium';
  } else if (score >= 8 && score <= 10) {
    return 'high';
  } 
};

// Function to format the date
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getUTCDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getUTCFullYear();
  
  return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
};


 // Socket variables
 useEffect(() => {
  const socket = new WebSocket(`wss://staging1.askzoi.com/intent_report_stream/${repId}/`);

  // Connection opened
  socket.addEventListener('open', function (event) {
  });

  // Listen for messages
  socket.addEventListener('message', function (event) {
      // console.log('Message from server:', event.data);
      // Display incoming message in the chat box
      const data =JSON.parse(event.data);
      // setFMessage(data?.answer)
      // setIsWriting(data?.is_writing)
      // console.log(data?.answer,"answer")
      // console.log(data,"write")
      // appendMessage("Server Message =" + event.data);
      console.log(data,"data")
      setReportData(data);
  });

  // Error handling
  socket.addEventListener('error', function (error) {
      console.error('WebSocket encountered error:', error);
  });

  // return () => {
  //     socket.close();
  // };
}, [repId]);


// Socket variables


  return (
    <div className="grid grid-cols-12 ">
    <div className="col-span-3  h-[100vh]">
        <div className="flex-col pt-20 px-8 overflow-y-auto removeScroll h-[98vh]">
        <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-sm text-black font-[500]"
                    >
                      Number of News Articles
                    </label>
                    <div className="flex">
                    <input
                    inputProps={{ maxLength: 10}}
                      type="number"
                      name="articleNumber"
                      value={formData.articleNumber}
                      onChange={(e)=>{setArticleNumber(e.target.value)}}
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                    />
                    </div>
        </div>
        <div className="rounded-md bg-white px-3 pb-1.5 mt-2 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="colorMode"
                      className="block text-sm text-black font-[500]"
                    >
                      Freshness
                    </label>
                    
                    <SimpleSelect
                      people={freshnessTimeline}
                      selected={freshnessSelected}
                      setSelected={setFreshnessSelected}
                    />
                  </div>
        <div className="rounded-md bg-white px-3 pb-1.5 mt-2 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
                    <label
                      htmlFor="colorMode"
                      className="block text-sm text-black font-[500]"
                    >
                      Select
                    </label>
                    
                    <SimpleSelect
                      people={selectTimeline}
                      selected={selectedC}
                      setSelected={setSelectedC}
                    />
                  </div>
        <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-sm text-black font-[500]"
                    >
                      Client Name
                    </label>
                    <div className="flex">
                    <input
                       type="text"
                       name="clientName"
                       value={formData.clientName}
                       onChange={handleChange}
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                    />
                    </div>
        </div>
        <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-sm text-black font-[500]"
                    >
                      System Prompt
                    </label>
                    <div className="flex">
                    <input
                       type="text"
                       name="searchQuery"
                       value={searchQuery}
                       onChange={(e)=>setSearchQuery(e.target.value)}
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                    />
                    </div>
        </div>
        <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-sm text-black font-[500]"
                    >
                      Trigger Selected
                    </label>
                    <div className="flex">
                    <input
                       type="text"
                       name="triggerSelected"
                       value={triggerSelected}
                       onChange={(e)=>setTriggerSelected(e.target.value)}
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                    />
                    </div>
        </div>
        <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-sm text-black font-[500]"
                    >
                      Target {`${selectedC?.name == "Company" ? "Companies" : "Industries"}`}
                    </label>
                    <div className="flex">
                    <input
                       type="text"
                       name="targetIndustries"
                       value={formData.targetIndustries}
                       onChange={handleChange}
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                    />
                    </div>
        </div>
        <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-sm text-black font-[500]"
                    >
                      About Seller
                    </label>
                    <div className="flex">
                    <input
                      type="text"
                      name="aboutSeller"
                      value={formData.aboutSeller}
                      onChange={handleChange}
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                    />
                    </div>
        </div>
        <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
                    <label
                      htmlFor="name"
                      className="block text-sm text-black font-[500]"
                    >
                      About Offering
                    </label>
                    <div className="flex">
                    <input
                      type="text"
                      name="aboutOffering"
                      value={formData.aboutOffering}
                      onChange={handleChange}
                      className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                      placeholder="Enter Text Here"
                    />
                    </div>
        </div>
        <div onClick={handleSubmit} className="bg-[#49BCD2] text-white p-2 rounded-md w-[20%] ml-auto text-xl my-auto text-center cursor-pointer">{`->`}</div>       
        </div>
    </div>
    <div className="pt-16 col-span-9 bg-[#f3f4f6] overflow-y-auto h-[99vh]">
      {(isLoading  || repStatus?.report_status == "queued" || repStatus?.report_status == "processing") ? <div className="flex justify-center"><img src={Jump} className="w-48 h-48 mt-48 "/>
</div> :
      <>   
    {repData?.length > 0 ? 
    repData?.map((item) => {
            return (
      <div className=" mx-16 my-10 justify-center flex-col intentContainer bg-white shadow-lg rounded-lg pt-2 pb-10 px-8">
        <div className="flex justify-between w-full border-b-[2px] border-gray-200 border-solid">
          <div className="flex mt-5 mb-4">
            <div className="font-bold text-sm mr-5 my-auto cursor-pointer" title={item?.new_title}>
              {item?.new_title?.length > 50 ? `${item?.new_title?.slice(0,50)}...`:item?.new_title}
            </div>
            <div className="text-gray-400 font-semibold text-sm bg-gray-100 px-2 py-1 my-auto rounded-md" title={item?.triggers_its_relevant_to[0]}>
              {item?.triggers_its_relevant_to[0]?.length > 30 ? `${item?.triggers_its_relevant_to[0]?.slice(0,30)}...`:item?.triggers_its_relevant_to[0]}
            </div>
          </div>
          <div className="font-bold text-sm mr-5 my-auto">{formatDate(item?.date)}</div>
        </div>
        <div className="w-full text-base mt-8">
          {item?.summary}
        </div>
        <div className="w-full text-base mt-1 text-gray-800 cursor-default">
          Source: <span title={item?.source} onClick={()=>{window.open(item?.source, '_blank')}} className="italic cursor-pointer">{item?.source?.length > 40 ? `${item?.source?.slice(0,40)}...`:item?.source}</span> 
        </div>
        {/* <div className="w-full text-base mt-1 text-[#007AFF] cursor-pointer font-semibold">
          Read More
        </div> */}
        <div className="mt-6 border-solid border-[2px] rounded-md border-[#757575] bg-gray-100 py-4 px-2 text-base">
          <div className="mb-6 font-bold">
            Relevancy:<span className={` capitalize ${categorizeScore(item?.relevance_score) == "high" ? "text-green-500":categorizeScore(item?.relevance_score) == "medium" ? "text-[#FF9500]" : "text-red-500"}`}> {categorizeScore(item?.relevance_score)}</span>
          </div>
          <div>
            {item?.relevance}
          </div>
        </div>
        {item?.action_items?.length > 0 && <div className="mt-6 text-base">
            <div className="mb-6 font-bold">Suggested Actions:</div>
            <div className="list-decimal">
              {item?.action_items?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
        </div>}
      </div>
            )}) :
            <div className="flex justify-center mt-48 text-xl text-gray-800">Fill the Data to generate the report</div>
          }
      </>}
    </div>
    </div>
  );
};

export default Intent;
